/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React, { lazy, Fragment } from 'react';
import { FormStateChangeNotifier } from '../form';
var styles = css({
  lineHeight: '20px'
});
var Field = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var AkRadioGroup = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.radio' */
  '@atlaskit/radio/RadioGroup');
});
var AKHelperMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.HelperMessage
    };
  });
});
var RadioGroup = function RadioGroup(_ref) {
  var options = _ref.options,
    defaultValue = _ref.defaultValue,
    isRequired = _ref.isRequired,
    label = _ref.label,
    description = _ref.description,
    name = _ref.name;
  return jsx(Field, {
    defaultValue: defaultValue,
    isRequired: isRequired,
    label: label,
    name: name
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps;
    var id = fieldProps.id,
      isRequired = fieldProps.isRequired,
      isDisabled = fieldProps.isDisabled,
      isInvalid = fieldProps.isInvalid,
      onChange = fieldProps.onChange,
      value = fieldProps.value,
      ariaLabelledBy = fieldProps['aria-labelledby'];
    return jsx(Fragment, null, jsx(FormStateChangeNotifier, {
      name: name,
      value: fieldProps.value
    }), description && jsx(AKHelperMessage, null, description), jsx("div", {
      css: styles
    }, jsx(AkRadioGroup, {
      "test-id": id,
      isRequired: isRequired,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      onChange: onChange,
      value: value,
      "aria-labelledby": ariaLabelledBy,
      options: options
    })));
  });
};
var RadioGroupFn = function RadioGroupFn(_ref3) {
  var props = _ref3.props,
    children = _ref3.children;
  var _ref4 = props,
    label = _ref4.label,
    name = _ref4.name,
    isRequired = _ref4.isRequired,
    description = _ref4.description;
  var defaultValue;
  var options = children.map(function (child) {
    var props = child.props,
      type = child.type;
    if (type === 'Radio') {
      var _ref5 = props,
        _label = _ref5.label,
        value = _ref5.value,
        defaultChecked = _ref5.defaultChecked;
      if (defaultChecked) {
        defaultValue = value;
      }
      return {
        name: name,
        label: _label,
        value: value
      };
    }
  }).filter(function (option) {
    return typeof option !== 'undefined';
  });
  return jsx(RadioGroup, {
    label: label,
    name: name,
    options: options,
    defaultValue: defaultValue,
    description: description,
    isRequired: isRequired
  });
};
export { RadioGroup, RadioGroupFn };